/**
 * アクション用のType
 */

export const SET_TEXT = "SET_TEXT";
export const REMOVE_TEXT = "REMOVE_TEXT";
export const CLEAR_TEXT = "CLEAR_TEXT";

//jyua001
export const JYUAT001_ADD = "JYUAT001_ADD";
export const JYUAT001_UPD = "JYUAT001_UPD";
export const JYUAT001_DEL = "JYUAT001_DEL";
export const JYUAT001_GET = "JYUAT001_GET";

//kbnvalue
export const GET_KBN = "GET_KBN";